import React, { useEffect, useState } from "react";
import Breadcrumb from "components/Common/Breadcrumb";
import Loading from "components/Common/Loading";
import image from "./image.json";
import powerBiService from "services/PowerBiService";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import { SendaCustomSwal } from "components/Common/SendaCustomSwal";

const RelatoriosPowerBI = () => {
	const navigate = useNavigate();
	const [relatorios, setRelatorios] = useState([]);
	const [isLoading, setIsLoading] = useState(false);

	const getRelatorios = async () => {
		setRelatorios(await powerBiService.getRelatorios());
	};

	const obterDados = async () => {
		try {
			setIsLoading(true);
			await Promise.all([getRelatorios()]);
			setIsLoading(false);
		} catch (e) {
			SendaCustomSwal.fire({
				iconHtml: '<i class="error-icon"></i>',
				title: "Oops...",
				text: "Falha ao buscar os itens recarregue a página!",
				customClass: {
					confirmButton: "custom-confirm-button",
				},
			});
		}
		setIsLoading(false);
	};

	useEffect(() => {
		obterDados();
	}, []);

	const handleClick = (id) => {
		navigate(`/dashboard-power-bi/${id}`);
	};

	return (
		<Loading isLoading={isLoading}>
			<div className="page-content">
				<Breadcrumb title="Inteligência Empresarial BI" />

				<div
					className="container-fluid"
					style={{
						backgroundColor: "white",
						padding: 20,
						borderRadius: 10,
						marginTop: 25,
					}}
				>
					<div
						style={{
							display: "grid",
							gridTemplateColumns: "repeat(4, 1fr)", // 4 colunas
							gap: "20px",
						}}
					>
						{relatorios.map((item) => (
							<div
								key={item.id}
								style={{
									display: "flex",
									flexDirection: "column",
									alignItems: "center",
									border: "1px solid #ddd",
									borderRadius: 8,
									padding: 10,
									boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
									transition: "box-shadow 0.3s",
									cursor: "pointer",
								}}
								onMouseEnter={(e) => {
									e.currentTarget.style.boxShadow =
										"0 4px 16px rgba(0, 0, 0, 0.2)";
								}}
								onMouseLeave={(e) => {
									e.currentTarget.style.boxShadow =
										"0 2px 8px rgba(0, 0, 0, 0.1)";
								}}
								onClick={() => handleClick(item.id)}
							>
								<img
									src={image.base64}
									alt={item.name}
									onError={(e) => {
										e.target.src =
											"https://via.placeholder.com/150"; // Imagem fallback
									}}
									style={{
										width: "85px",
										height: "80px",
										borderRadius: 5,
										marginBottom: 10,
										objectFit: "cover",
									}}
								/>
								<h5>{item.name}</h5>
							</div>
						))}
					</div>
				</div>
			</div>
		</Loading>
	);
};

export default RelatoriosPowerBI;
